<div class="sitemap-wrapper bg-fff">
    <div class="row">
        <h1 class="mb-4 fnt-32 fnt-md-40 fw-b fnt-head col-6 col-md-8 col-xl-9">
            {{ 'all_coffee_outlets' | translate }}
        </h1>
        <a
            class="back-page mt-2 text-clr24 col-6 col-md-4 col-xl-3 h-100 text-hover-clr24"
            routerLink="/{{ 'coffee' | translate }}"
            >{{ 'back_to_outlets' | translate }}</a
        >
    </div>
    <hr />
    <div *ngFor="let country of getCountries()">
        <h2 class="mt-4 fnt-20 fw-b fnt-general text-clr24 country">{{ country }}</h2>
        <div class="row">
            <div *ngFor="let city of getCities(country)" class="col-lg-3 col-6">
                <a
                    routerLink="/{{ 'coffee' | translate }}/{{ city.toLowerCase() }}"
                    class="text-uppercase fnt-general fnt-16 fw-b text-clr24 mt-4 mt-md-0 d-block d-md-inline"
                    >{{ city }}</a
                >
                <div *ngFor="let outlet of getCityOutlets(country, city)">
                    <a
                        routerLink="/{{ 'coffee' | translate }}/{{ city.toLowerCase() }}/{{
                            outlet.slug.toLowerCase()
                        }}"
                        class="mt-3 text-clr24 fnt-18 text-underline fnt-general"
                    >
                        {{ outlet.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
